import React, { useEffect, useState } from 'react';

import { type TicketsReward } from '@/common/types/lottery';
import { type ArenaPackRewardDto } from '@/common/types/shop/marketBoxes';
import { useAppSelector } from '@/redux/store';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { type ProfitDropRewardType } from '../config';

import ProfitDropRewardFlipCard from './Rewards/ProfitDropRewardFlipCard';

import 'swiper/css';

import profitDropIcon from '/img/shop/arenaOffers/profitDropIcon.svg';

const ProfitDropReward: React.FC = () => {
  const activeCard = useAppSelector(
    (state) => state.shop.activeProfitDropOffer,
  );
  const [activeKey, setActiveKey] = useState<ProfitDropRewardType>();

  const keys: ProfitDropRewardType[] = [
    'arenaOffer',
    'usdt',
    'lottery',
    'tgem',
  ];

  useEffect(() => {
    setActiveKey(keys[0]);
    const interval = setInterval(() => {
      setActiveKey((prev) => {
        if (!prev) return 'arenaOffer';
        const index = keys.indexOf(prev);

        if (index === keys.length - 1) return keys[0];

        return keys[index + 1];
      });
    }, 2000);

    return (): void => clearInterval(interval);
  }, []);

  if (!activeCard) return null;

  const getAmountFromValue = (
    value: number | ArenaPackRewardDto | Partial<TicketsReward> | undefined,
  ): number => {
    const isClasicObject = typeof value === 'object' && value !== null;

    if (isClasicObject && 'goldTicket' in value) {
      return value.goldTicket || 0;
    }

    if (isClasicObject) {
      return 0;
    }

    return value || 0;
  };
  const getReward = (key: ProfitDropRewardType): number => {
    const targetReward = activeCard.reward[key];

    return getAmountFromValue(targetReward);
  };

  return (
    <div className="grid grid-cols-[6rem_6rem] gap-1 -my-2 relative">
      {keys.map((key) => (
        <ProfitDropRewardFlipCard
          status={activeKey === key ? 'revealed-reward' : 'hidden'}
          type={key}
          value={getReward(key)}
          delay={activeKey === key ? 0.3 : 0}
          key={key}
          size="sm"
          noBorder
        />
      ))}
      <img
        src={profitDropIcon}
        alt="chance icon"
        className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute z-10"
      />
    </div>
  );
};

export default ProfitDropReward;
